

import { loginForHTX,loginByUsername, logout, getUserInfo, getSystemTime, selectDisVerificationCode, getVerificationCodeImg, getVerificationCodeData, selectUserBindRoleByUserId,selectPriCloudTimeInfo} from '@/api/login'
import { getToken, setToken, removeToken,setSysTime,getSysTime,removeSysTime,
  getVerificationCode,setVerificationCode,removeVerificationCode,
  getAvatar,setRoletype,getRoletype,getDiskPath,setDiskPath,removeDiskPath,setSystemName,getSystemName,setAvatar,getBroadcastId,setBroadcastId,
  setIsManage,getIsManage,setMessageType,getMessageType,getRouterType,setRouterType,removeRouterType,getScheduleId,removeScheduleIde,setScheduleId,getInventoryId,setInventoryId,setUserName,getUserName,
  getEndOrgName,setEndOrgName,getUserStatus,setUserStatus,getThirdUrl,setThirdUrl,getMediaTimeState,setMediaTimeState,setIspassGuide,setIsReadVersion,getIsReadVersion,getIspassGuide,getmediaTimeStateObject,setmediaTimeStateObject
} from '@/utils/auth'
//加载密码加密js
import { hex_sha1 } from '@/common/js/ha1'
import md5 from 'js-md5';
import {recordBehaviorsAfter} from "../../monitoring/performanceMonitoring";
import {GetUrlRelativePath} from "../../utils";
import $router from '@/router'
let _this = this
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    },
    systemtime:getSysTime(),
    avatar:getAvatar(),
    verificationCode:getVerificationCode(),
    roletype:getRoletype(),
    sysdiskpath:getDiskPath(),
    systemName:getSystemName(),
    broadcastId:getBroadcastId(),
    isManage:getIsManage(),
    messageType:getMessageType() == undefined ? 1 : getMessageType(),
    routerType:getRouterType(),
    scheduleId:getScheduleId(),
    inventoryId:getInventoryId(),
    userName:getUserName(),
    endOrgName:getEndOrgName(),
    userStatus:getUserStatus(),
    thirdUrl:getThirdUrl(),
    mediaTimeState:getMediaTimeState(),
    mediaTimeStateObject:getmediaTimeStateObject(),
    ispassGuide:getIspassGuide(),
    isReadVersion:getIsReadVersion(),

  },

  mutations: {
    SET_mediaTimeState: (state, mediaTimeState) => {
      state.mediaTimeState = mediaTimeState
      setMediaTimeState(mediaTimeState)
    },
    SET_mediaTimeStateObject: (state, mediaTimeStateObject) => {
      state.mediaTimeStateObject = mediaTimeStateObject
      setmediaTimeStateObject(mediaTimeStateObject)
    },
    //第三方登录返回路径
    SET_THIRDURL: (state, thirdUrl) => {
      state.thirdUrl = thirdUrl
      setThirdUrl(thirdUrl)
    },
    SET_USERSTAUS: (state, userStatus) => {
      state.userStatus = userStatus
      setUserStatus(userStatus)
    },
    SET_SCHEDULEID: (state, scheduleId) => {
      state.scheduleId = scheduleId
    },
    SET_INVENTORYID: (state, inventoryId) => {
      state.inventoryId = inventoryId
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ISMANAGE:(state, isManage) => {
      //获取系统时间
      state.isManage = isManage
      setIsManage(isManage)
    },
    SYS_TEMTIME: (state, systemtime) => {
      //获取系统时间
      state.systemtime = systemtime
      setSysTime(systemtime)
    },
    SYS_DISKPATH:(state, sysdiskpath) => {
      state.sysdiskpath = sysdiskpath
      setDiskPath(sysdiskpath)
    },
    SET_AVATAR:(state, avatar) => {
      state.avatar = avatar
      setAvatar(avatar)
    },
    SET_VERIFICATIONCODE:(state, verificationCode) => {
      //获取系统时间
      state.verificationCode = verificationCode
      setVerificationCode(verificationCode)
    },
    SET_BROADCASTID:(state, broadcastId) => {
      //获取系统时间
      state.broadcastId = broadcastId
      setBroadcastId(broadcastId)
    },
    SET_ROLETYPE:(state, roletype) => {
      //获取系统时间
      state.roletype = roletype
      setRoletype(roletype)
    },
    SET_SYSTEMNAME:(state, systemName) => {
      //获取系统时间
      state.systemName = systemName
      setSystemName(systemName)
    },
    SET_MESSAGETYPE:(state, messageType) =>{
      //获取系统时间
      state.messageType = messageType
      setMessageType(messageType)
    },
    SET_ROUTERTYPE:(state, routerType) =>{
      //获取系统时间
      state.routerType = routerType
      setRouterType(routerType)
    },
    SET_USERNAME:(state, userName) =>{
      //获取系统时间
      state.userName = userName
      setUserName(userName)
    },
    SET_ENDORGNAME:(state, endOrgName) =>{
      //获取系统时间
      state.endOrgName = endOrgName
      setEndOrgName(endOrgName)
    },
    SET_ISPASSGUIDE:(state, ispassGuide) =>{
      state.ispassGuide = ispassGuide
      setIspassGuide(ispassGuide)
    },
    SET_ISREADVERSION:(state, isReadVersion) =>{
      state.isReadVersion = isReadVersion
      setIsReadVersion(isReadVersion)
    }
  },

  actions: {

    //获取验证码
    selectDisVerificationCode({ commit }, userInfo) {
      const username = userInfo.username.trim()
      let jsonBody = {userName: username}
      return new Promise((resolve, reject) => {
        selectDisVerificationCode({jsonBody:jsonBody}).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // getVerificationCodeImg({ commit }, userInfo){
    //   // const username = userInfo.username.trim()
    //   return new Promise((resolve, reject) => {
    //     // let jsonBody = {userName: username}
    //     getVerificationCodeImg().then(response => {
    //       resolve(response)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    getVerificationCodeData({ commit }, userInfo){
      return new Promise((resolve, reject) => {
        // let jsonBody = {userName: username}
        getVerificationCodeData().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        let userOtherPwd = md5(userInfo.password)
        let password_sha = hex_sha1( userInfo.password )
        let jsonBody = {userName: username,userPwd:password_sha,verCode:userInfo.verCode,verKeyCode:getVerificationCode(),userOtherPwd:userOtherPwd}
        loginByUsername({jsonBody:jsonBody}).then(response => {
          let rtnCode = response.jsonBody.rtnCode
          if(rtnCode == 0){
            const data = response.jsonBody.msgBody
            commit('SET_TOKEN', data.accessToken)
            commit('SET_AVATAR', data.userHeadImg)
            commit('SET_ROLETYPE', data.userStyle)
            commit('SET_ISMANAGE', data.isManage)
            commit('SET_SYSTEMNAME', data.systemName)
            commit('SET_USERNAME', data.userName)
            commit('SET_ENDORGNAME', data.endOrgName)
            commit('SET_ISPASSGUIDE',data.isPassGuide)
            commit('SET_ISREADVERSION',data.isReadVersion)
            setToken(data.accessToken)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    loginForHTX({ commit }, token){
      commit('SET_TOKEN', token)
      commit('SET_USERSTAUS',1)
      return new Promise((resolve, reject) => {
        let jsonBody = {accessToken: token,type:0}
        loginForHTX({jsonBody:jsonBody}).then(response => {
          let rtnCode = response.jsonBody.rtnCode
          if(rtnCode == 0){
            const data = response.jsonBody.msgBody
            commit('SET_TOKEN', data.accessToken)
            commit('SET_AVATAR', data.userHeadImg)
            commit('SET_ROLETYPE', data.userStyle)
            commit('SET_ISMANAGE', data.isManage)
            commit('SET_SYSTEMNAME', data.systemName)
            commit('SET_USERNAME', data.userName)
            commit('SET_ENDORGNAME', data.endOrgName)

            commit('SET_THIRDURL', data.thirdUrl)
            setToken(data.accessToken)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject('error')
          }
          const data = response.data

          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }

          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetSystemTime({ commit, state }) {
      return new Promise((resolve, reject) => {
        getSystemTime({}).then(res => {
          let jsonBodyData = res.jsonBody
          commit('SYS_TEMTIME', jsonBodyData.msgBody.dateTime)//存储系统事件
          setSysTime(jsonBodyData.msgBody.dateTime)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    selectPriCloudTimeInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        let jsonHead = {'accessToken':getToken()}
        selectPriCloudTimeInfo(jsonHead).then(res => {
          let jsonBodyData = res.jsonBody
          commit('SYS_DISKPATH', jsonBodyData.msgBody)//存储系统事件
          //console.log(jsonBodyData.msgBody)
          setDiskPath(jsonBodyData.msgBody)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    selectUserBindRoleByUserId({ commit, state }){  //权限
      return new Promise((resolve, reject) => {
        selectUserBindRoleByUserId({}).then(res => {
          let jsonBodyData = res.jsonBody
          let codes = jsonBodyData.msgBody.codes
          //console.log(state.roletype)
          if(state.roletype == 1 || state.roletype == 0){

          }else {

          }
          // if(state.roletype == 1 || state.roletype == 0){


          // codes.forEach(function (item, index) {
          //   if(permission.componentModule[item] == undefined){
          //
          //   }else {
          //     permission.componentModule[item].hidden = false
          //   }
          // })



          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage"].hidden = true
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage1"].hidden = false
          // }else if(state.roletype == 2){
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage"].hidden = false
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage1"].hidden = true
          // }else {
          //   codes.forEach(function (item, index) {
          //     if(permission.componentModule[item] == undefined){
          //     }else {
          //       permission.componentModule[item].hidden = false
          //     }
          //   })
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage"].hidden = true
          //   permission.componentModule["V3_0_IQManageCenter_OrganizationManage1"].hidden = false
          // }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        recordBehaviorsAfter($router.history.current).then(() => {
          logout(state.token).then(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_BROADCASTID', '')
            localStorage.removeItem("router");
            removeToken()
            resolve()
          }).catch(error => {
            reject(error)
          })
        }).catch(err => {
          console.log('err',err)
        });
      })
    },

    // 前端 登出return new Promise(resolve => {
    //         commit('SET_mediaTimeState',mediaTimeState)
    //         resolve()
    //       })
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    setDispatchMediaTimeState({commit},mediaTimeState){

    },
    setmediaTimeStateObject({commit},mediaTimeStateObject){
      return new Promise(resolve => {
        commit('SET_mediaTimeStateObject',mediaTimeStateObject)
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js